<div class="contenedor-form" *ngIf="loadingDireccion">
  <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
</div>

<div style="text-align: center; margin-bottom: 20px;" *ngIf="!loadingDireccion">
  <form [formGroup]="direccionGroup" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="NOMBRE DIRECCION" formControlName="NombreDireccion" type="text" />
        </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
        <select style="margin-top: 15px;" formControlName="idDepto">
          <option value="" disabled selected>DEPARTAMENTO</option>
          <option *ngFor="let opt of departamentos" [value]="opt.id">
            {{ opt.valor }}
          </option>
        </select>
      </div>
      <div class="col s12 m4 l4">
        <select style="margin-top: 15px;" formControlName="idMunicipio">
          <option value="" disabled selected>CIUDAD</option>
          <option *ngFor="let opt of ciudades" [value]="opt.id">
            {{ opt.valor }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="DIRECCIÓN" formControlName="Direccion" type="text" />
        </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="TELEFONO" formControlName="Telefono" type="text" />
        </mat-form-field>
      </div>
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="TELEFONO 2" formControlName="Telefono2" type="text" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col s12 m4 l4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="OBSERVACIÓN" formControlName="Observacion" type="text" />
        </mat-form-field>
      </div>
    </div>
    <button mat-raised-button type="submit" color="accent" [disabled]="!direccionGroup.valid">
      Actualizar
    </button>
  </form>
</div>